var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
/* Template for rendering pagination in JS

    pages: passed object with options for whole pagination
    total: total number of pages
    current: the currently shown page number
    left: number of pages always shown on the left
    right: number of pages always shown on the right
    insideWindow: number of pages always shown on both sides of current page

 */
__p+='\n\n';

  let {
    pages
  } = options;

__p+='\n\n\n<nav class="pagination">\n\n    ';

        var total = pages.total,
            current = pages.current,
            left = pages.left,
            right = pages.right,
            insideWindow  = pages.insideWindow,
            isCurrentFirst = current=== 1 ? true : false,
            isCurrentLast = current === total ? true : false,
            isLeftOuter,
            isRightOuter,
            isInsideWindow,
            isPageTruncated = false;

    
__p+='\n    '+
((__t=( JST["templates/pagination/prev_page"]({isCurrentFirst: isCurrentFirst})))==null?'':__t)+
'\n    ';

        for (var i=1; i <= total; i++) {

            isInsideWindow = (current - insideWindow <= i && i <= current + insideWindow)? true : false;
            isLeftOuter = i <= left ? true : false;
            isRightOuter = (total - i) < right ? true : false;

            if ( isLeftOuter || isRightOuter || isInsideWindow) {
                var page = {number:i, isCurrent: i === current};
                isPageTruncated = false;

    
__p+='\n    '+
((__t=( JST["templates/pagination/page"]({page: page})))==null?'':__t)+
'\n    ';

            }
            else if ( !isPageTruncated) {
                isPageTruncated = true;
    
__p+='\n    '+
((__t=( JST["templates/pagination/gap"]()))==null?'':__t)+
'\n    ';

            }
        }
    
__p+='\n\n    '+
((__t=( JST["templates/pagination/next_page"]({isCurrentLast: isCurrentLast})))==null?'':__t)+
'\n\n</nav>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/pagination/paginator.jst.ejs